export const ERROR_CODE = {
  ERR_UNEXPECTED_ERROR: "error.unexpect.bind",
  ERR_INVALID_ERROR: "error.unexpect.method-argument-not-valid",
  ERR_PARAM_CHECK_FAIL: "error.ParameterCheckFailure",
  ERR_FILE_CREATE_FAILURE: "error.business.FileCreateFailure",
  RESOURCE_NOT_FOUND: "springer.error.rest.resource-not-found",
  UPS_API_CALL_ERROR_RETRIABLE: "error.business.UpsApiErrorRetriable",
  UPS_API_CALL_ERROR_NO_RETRY: "error.business.UpsApiErrorNoRetry",
  UPS_API_CALL_ERROR_INPUT_MISMATCH: "validation.InputMismatch",
  UPS_API_CALL_ERROR_LOCATION_NOT_SUPPORT: "validation.LocationNotSupport",
  UPS_API_CALL_ERROR_CONSIGNEE_ZIP_NOT_EXIST: "validation.ConsigneeZipNotExist",
  UPS_API_CALL_ERROR_REISSUE: "validation.ErrorReissued",
  UPS_API_CALL_ERROR_VAT_REGISTER_NUMBER: "validation.VatRegisterNumberError",
  UPS_API_CALL_ERROR_PAYMENT_DIV_NOT_SUPPORT: "validation.PaymentDivNotSupport",
  UPS_API_ACCESS_TOKEN_ERROR: "error.business.UpsApiAccessTokenError",
  UPS_API_CALL_ERROR_HANDWRITE_ONLY: "validation.HandwriteOnly",
  UPS_API_CALL_ERROR_MISSING_SKU: "validation.MerchantProductIdentifierIsRequired",
  UPS_API_CALL_ERROR_MISSING_MPN: "validation.ManufacturerProductIdentifierIsRequired",
  UPS_API_CALL_ERROR_MISSING_PID: "validation.ProductIDIsRequired",
  UPS_API_CALL_ERROR_MISSING_CCEI: "validation.InvalidProductIdentifierExemptIndicator"
};
